/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Person {
  addressId?: number;
  badgeId?: number;
  badgeIdIsManual?: boolean;
  billingInfoId?: number;
  birthday?: Date;
  businessUnitId?: number;
  couponName?: string;
  cpf?: number;
  dateCouponNameEdited?: Date;
  dateCreated?: Date;
  dateUpdated?: Date;
  facebookAccessToken?: string;
  facebookAccessTokenExpiration?: number;
  facebookId?: number;
  fullName?: string;
  gender?: string;
  inviterId?: number;
  lastName?: string;
  maxipagoCustomerId?: string;
  name?: string;
  nameImageProfile?: string;
  newsletterOptIn?: boolean;
  personId?: number;
  personStatus?: number;
  phone?: string;
  registrationHost?: string;
  registrationIP?: string;
  registrationMedium?: string;
  registrationURL?: string;
  role?: string;
  shippingInfoId?: number;
  syncGlamShop?: number;
  urlImageProfile?: string;
  username?: string;
  utmCampaign?: string;
  utmContent?: string;
  utmMedium?: string;
  utmSource?: string;
}
